import Vue from 'vue'
import Vuex from 'vuex'
import task from './modules/task'
import places from './modules/places'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
  modules: {
    task,
    places
  },
  strict: debug,
})
export default store